// import './App.sass';
import Main from'./pages/main';
import Intro from'./pages/intro';
import Result from'./pages/result';
import Test from'./pages/test';
import React, { Component } from 'react';
export default class App extends Component {
  constructor(props) {
		super(props);
		this.state = {
			page: 0,
      step: 0,
      score: 0,
      answers: [],
		};
    this.app = '';
	}
	updatePage = (page) => {
		this.setState(
			{
				page: page,
			}
		);
	};
	updateScore = (score) => {
		this.setState(
			{
				score: score,
			}
		);
	};
	render() {
    switch (this.state.page) {
      case 0:
        this.app = <Main updatePage={this.updatePage}/>;
        break;
      case 1:
        this.app = <Intro updatePage={this.updatePage}/>;
        break;
      case 2:
        this.app = <Test updatePage={this.updatePage} updateScore={this.updateScore}/>;
        break;
      case 3:
        this.app = <Result updatePage={this.updatePage} score={this.state.score}/>;
        break;
    
      default:
        this.app = <Main updatePage={this.updatePage}/>;
        break;
    }
    
    
    return (
      
      <>
        <div className="App">
        {this.app}
        </div>
      </>
    );
  }
}
